export const OfferTypes = {
  Generic_Code: _TL_('Generic code'),
  No_Code: _TL_('No code'),
};
